import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

//angular material
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatCardModule } from '@angular/material/card';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatDividerModule } from '@angular/material/divider';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { OverlayModule } from '@angular/cdk/overlay';
import { MatDialogModule } from '@angular/material/dialog';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatChipsModule } from '@angular/material/chips';
const MaterialComponents = [
  MatProgressSpinnerModule,
  MatDialogModule,
  MatTabsModule,
  OverlayModule,
  MatDividerModule,
  MatCheckboxModule,
  MatCardModule,
  MatSidenavModule,
  MatRadioModule,
  MatChipsModule,
  MatToolbarModule,
  MatIconModule,
  MatFormFieldModule,
];

@NgModule({
  declarations: [],
  imports: [],
  exports: [MaterialComponents],
})
export class MaterialModule {}
